<template>
  <div>
    <ListItemFilters
      icon="ui-icon-map-pin"
      :title="doctorFiltersState.city?.name || t('Город врача', options)"
      :subtitle="doctorFiltersState.city ? t('Город врача', options) : ''"
      @click="openDialog"
    />

    <CityModal
      :value="isDialogOpened"
      is-back
      :selected-city="filtersStore.unsavedFilters.city"
      @city:selected="onClickCity"
      @city:reset="onResetCity"
      @input="handleCloseCityModal"
    >
      <template #footer="{ selectedCity }">
        <div class="pa-2 elevation-8">
          <v-btn
            block
            depressed
            color="primary"
            :disabled="!hasUnsavedCity"
            @click="handleCitySelected(selectedCity)"
          >
            {{ t('Применить', options) }}
          </v-btn>
        </div>
      </template>
    </CityModal>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import deepEqual from 'www/vue_components/common/TheFilters/doctors/functions/deepEqual'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import ListItemFilters from 'www/vue_components/common/TheFilters/common/components/ListItemFilters/ListItemFilters.vue'
import CityModal from 'www/vue_components/common/TheFilters/doctors/components/CityFilters/components/CityModal.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ListItemCity')

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: doctorFiltersState } = toRefs(props)

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const hasUnsavedCity = computed(() => (
  !deepEqual(doctorFiltersState.value.city, filtersStore.unsavedFilters.city)
))

const handleCitySelected = (city: Filters['city']) => {
  closeDialog()

  emit('input', {
    ...doctorFiltersState.value,
    city,
  })
}

const handleCloseCityModal = () => {
  closeDialog()
  filtersStore.updateUnsavedFilters(doctorFiltersState.value)
}

const onClickCity = (city: Filters['city']) => {
  filtersStore.updateUnsavedFilters({ city })
}

const onResetCity = () => {
  filtersStore.updateUnsavedFilters({ city: undefined })
  handleCitySelected(undefined)
}
</script>
